// extracted by mini-css-extract-plugin
export default {"title":"AccountLayout_title__xK0WA","fullWidth":"AccountLayout_fullWidth__Pjfq-"};